import { render, staticRenderFns } from "./Grading.vue?vue&type=template&id=6731f9e5&scoped=true&"
import script from "./Grading.vue?vue&type=script&lang=js&"
export * from "./Grading.vue?vue&type=script&lang=js&"
import style0 from "./Grading.vue?vue&type=style&index=0&id=6731f9e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6731f9e5",
  null
  
)

export default component.exports